import type { OpsRole, PaymentStatus } from '../../api/types';
import styles from './Payments.module.css';
import { Button } from '../../components/ui/Button';
import { useTranslation } from 'react-i18next';

export function ApproveRejectBar({ paymentId, status, role, onApprove, onReject, pending = false }: {
  paymentId: number;
  status: PaymentStatus;
  role: OpsRole;
  onApprove: (paymentId: number) => void;
  onReject: (paymentId: number) => void;
  pending?: boolean;
}) {
  const { t } = useTranslation();
  if (role !== 'OPS_MANAGER' || status !== 'PENDING_APPROVAL') return null;
  return <div className={styles.actions}>
    <Button variant="danger" size="sm" disabled={pending} onClick={() => onReject(paymentId)}>{t('payments.approveRejectBar.reject')}</Button>
    <Button variant="primary" size="sm" disabled={pending} onClick={() => onApprove(paymentId)}>{t('payments.approveRejectBar.approve')}</Button>
  </div>;
}
